// Constantes de estilos para la aplicación

// Familias de fuentes
export const FONTS = {
  PRIMARY: '"AtHauss", "Avenir Next", sans-serif',
  SECONDARY: '"WorkSans", "Avenir Next", sans-serif',
  RETINA: '"AtHauss Retina", "AtHauss", "Avenir Next", sans-serif',
  FALLBACK: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif'
};

// Colores principales (complementando los definidos en :root en index.css)
export const COLORS = {
  PRIMARY: 'var(--primary-color)',
  SECONDARY: 'var(--secondary-color)',
  ACCENT: 'var(--accent-color)',
  TEXT: 'var(--text-color)',
  ERROR: 'var(--error-color)',
  SUCCESS: 'var(--success-color)',
  BORDER: 'var(--border-color)',
  BACKGROUND: 'var(--background-color)'
};

// Breakpoints para media queries
export const BREAKPOINTS = {
  MOBILE: '768px',
  TABLET: '1000px',
  LAPTOP: '1200px',
  DESKTOP: '1400px'
};

// Otras constantes de estilo
export const SHADOWS = {
  DEFAULT: 'var(--box-shadow)',
  FOCUS: '0px 0px 0px 2px var(--primary-color)'
}; 